export default {
  messages: {
    other: 'tw其他',
    hello: '{word} 哈囉！',
  },
};
